import { render, staticRenderFns } from "./ReportDescription.vue?vue&type=template&id=4d9fc0ad&"
import script from "./ReportDescription.vue?vue&type=script&lang=js&"
export * from "./ReportDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports